import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, HardHat } from "lucide-react";
import { useSite, imgUrl } from "@/context/SiteContext";
import LangSwitcher from "./LangSwitcher";

const LINKS = [
  ["#tentang", "nav.about", "tentang"],
  ["#layanan", "nav.services", "layanan"],
  ["#portofolio", "nav.portfolio", "portofolio"],
  ["#artikel", "nav.articles", "artikel"],
  ["#faq", "nav.faq", "faq"],
];

export const Logo = ({ dark }) => {
  const logo = useSite()?.site?.profile?.logo_url;
  return (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
    {logo ? <img src={imgUrl(logo)} alt="Logo" className="h-10 max-w-[56px] object-contain" data-testid="nav-logo-image" />
      : <span className="grid h-9 w-9 place-items-center bg-[#D97706] text-white"><HardHat size={18} /></span>}
    <span className={`leading-tight ${dark ? "text-white" : "text-[#0F2B48]"}`}>
      <span className="block text-sm font-extrabold tracking-tight">RIKONSTRUKSI</span>
      <span className="block font-mono text-[10px] tracking-[0.25em] opacity-70">UTAMA</span>
    </span>
  </Link>
  );
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { t } = useSite();
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-[#FAF9F6]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([href, key, id]) => (
            <a key={href} href={`/${href}`} data-testid={`nav-link-${id}`} className="text-sm font-medium text-slate-600 transition-colors hover:text-[#0F2B48]">{t(key)}</a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <LangSwitcher />
          <Link to="/admin/login" data-testid="nav-admin-login" className="font-mono text-xs uppercase tracking-widest text-slate-500 hover:text-[#0F2B48]">Admin</Link>
          <a href="/#konsultasi" data-testid="nav-consult-button" className="bg-[#0F2B48] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#D97706]">{t("nav.consult")}</a>
        </div>
        <div className="flex items-center gap-2 md:hidden"><LangSwitcher /><button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">{open ? <X /> : <Menu />}</button></div>
      </div>
      {open && (
        <div className="flex flex-col gap-4 border-t bg-white px-6 py-5 md:hidden">
          {LINKS.map(([href, key]) => <a key={href} href={`/${href}`} onClick={() => setOpen(false)} className="text-sm font-medium">{t(key)}</a>)}
          <Link to="/admin/login" className="text-sm font-medium">Admin CMS</Link>
        </div>
      )}
    </header>
  );
}
